import { profile } from "../data/content";
import { ArrowUpRight, Github, Linkedin, Mail, Phone, Whatsapp } from "./Icons";
import { Reveal } from "./Reveal";
import "./Contact.css";

const channels = [
  {
    icon: Mail,
    label: "E-mail",
    value: profile.email,
    href: `mailto:${profile.email}`,
  },
  {
    icon: Phone,
    label: "Telefone",
    value: profile.phone,
    href: profile.phoneHref,
  },
];

export function Contact() {
  return (
    <section id="contato" className="section container">
      <Reveal className="contact">
        <div className="contact__pattern" aria-hidden="true" />

        <div className="contact__inner">
          <div className="contact__intro">
            <span className="eyebrow">Contato</span>
            <h2 className="h2 contact__title">
              Vamos construir algo que{" "}
              <span className="serif-accent">funcione de verdade</span>.
            </h2>
            <p className="lead contact__lead">
              Tem um projeto em mente, uma integração para resolver ou uma dúvida
              técnica?
            </p>

            <div className="contact__actions">
              <a className="btn btn--primary" href={`mailto:${profile.email}`}>
                <Mail size={17} />
                Enviar e-mail
              </a>
              <a
                className="btn btn--ghost"
                href={profile.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Whatsapp size={17} />
                WhatsApp
              </a>
            </div>

            <div className="contact__socials">
              <a
                href={profile.github}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <Github size={18} />
              </a>
              <a
                href={profile.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                className="contact__resume"
                href={profile.resume}
                target="_blank"
                rel="noopener noreferrer"
              >
                Baixar currículo
                <ArrowUpRight size={15} className="icon icon--arrow" />
              </a>
            </div>
          </div>

          <ul className="contact__channels">
            {channels.map(({ icon: Icon, label, value, href }) => {
              const content = (
                <>
                  <span className="contact__channel-icon">
                    <Icon size={17} />
                  </span>
                  <span className="contact__channel-text">
                    <span className="contact__channel-label">{label}</span>
                    <span className="contact__channel-value">{value}</span>
                  </span>
                </>
              );

              return (
                <li key={label} className="contact__channel">
                  {href ? <a href={href}>{content}</a> : <div>{content}</div>}
                </li>
              );
            })}
          </ul>
        </div>
      </Reveal>
    </section>
  );
}
